import Dashboard from 'screens/dashboard/Dashboard';
import IndividualView from 'screens/viewUser/ViewUser';
import Compare from 'screens/compare/Compare';
import Overlay from './screens/journal/Journal';
import Player from './screens/player/Player';
import Users from "./screens/users/Users";
import Test from "./screens/test"
import Team from "./screens/team/team"
import Reports from 'screens/Report/Reports';
export const routes = [
  {
    name: 'Dashboard',
    element: <Dashboard />,
    path: '/dashboard',
  },
  {
    name: 'Users',
    element: <Users />,
    path: '/users',
  },
  {
    name: 'IndividualView',
    element: <IndividualView />,
    path: '/individualView',
  },
  {
    name: 'Compare',
    element: <Compare />,
    path: '/compare',
  },
  {
    name: 'Overlay',
    element: <Overlay />,
    path: '/juernal',
  },
  {
    name: 'Player',
    element: <Player />,
    path: '/patients',
  },
  {
    name: 'Reports',
    element: <Reports />,
    path: '/reports',
  },
  {
    name: 'test',
    element: <Test />,
    path: '/test',
  },
  {
    name: 'team',
    element: <Team />,
    path: '/team',
  },
];
